var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketshare1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 2.66669V8.00002C18.667 8.70726 18.9479 9.38554 19.448 9.88564C19.9481 10.3857 20.6264 10.6667 21.3337 10.6667H26.667",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 29.3334H23.9997C24.7069 29.3334 25.3852 29.0524 25.8853 28.5523C26.3854 28.0522 26.6663 27.3739 26.6663 26.6667V9.33335L19.9997 2.66669H7.99967C7.29243 2.66669 6.61415 2.94764 6.11406 3.44774C5.61396 3.94783 5.33301 4.62611 5.33301 5.33335V10",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35593 15.3493C4.54043 16.073 3.88147 16.9558 3.41952 17.9434C2.95757 18.9311 2.70238 20.0027 2.66963 21.0925C2.63687 22.1824 2.82724 23.2674 3.22904 24.281C3.63084 25.2946 4.23559 26.2153 5.00616 26.9867C5.77672 27.7581 6.69684 28.3638 7.71 28.7667C8.72317 29.1696 9.80799 29.3611 10.8979 29.3295C11.9877 29.2979 13.0596 29.0439 14.0478 28.583C15.0359 28.1221 15.9194 27.464 16.6439 26.6493",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 21.3333C11.6467 21.3333 11.3076 21.1928 11.0575 20.9428C10.8075 20.6927 10.667 20.3536 10.667 20V14.6666C10.667 13.9306 11.267 13.3226 11.9937 13.444C13.6341 13.7198 15.1477 14.5001 16.3239 15.6764C17.5002 16.8526 18.2805 18.3662 18.5563 20.0066C18.6777 20.732 18.0697 21.3333 17.3337 21.3333H12.0003Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketshare1);
export default __webpack_public_path__ + "static/media/marketshare-1.555d10eed8f81d404e8ff0d9e4515706.svg";
export { ForwardRef as ReactComponent };